import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  width: 120px;
  height: 40px;
  /* default/gray/100 */
  background: #F7FAFC;
  /* default/gray/400 */

  border: 1px solid #CBD5E0;
  box-sizing: border-box;
  border-radius: 4px;
`;

const CustomStyledInput = styled.input`
  color: transparent;
  outline: 0;
  width: 140px;
  margin: 20px 0 20px var(--space-s1);
  /* default/gray/100 */
  background: #F7FAFC;
  height: 40px;
  border-radius: 4px;

  > div {
    width: fit-content;
  }

  &::-webkit-file-upload-button {
    visibility: hidden;
  }

  &::before {
    display: flex;
    align-items: center;
    justify-content: center;

    //width: calc(100% - 0.125rem);
    height: 40px;

    text-align: center;
    line-height: 20px;
    content: 'Upload CSV';
    color: ${props => (props.disabled ? 'var(--gray-primary)' : 'var(--accent-text)')};
    //display: inline-block;

    /* text-sm/Medium */

    font-family: Metropolis, serif;

    border: 1px solid #CBD5E0;
    box-sizing: border-box;
    border-radius: 4px;
    padding: var(--space-s) 0;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    font-weight: 500;
    font-size: var(--font-xs);
    transition: 0.2s background-color ease-in;
  }

  &:hover::before {
    background-color: var(--gray-secondary);
  }

  &:active {
    outline: 0;
  }

  &::before {
  }
`;

function CsvUploadFile(props) {
    const {onChange, disabled} = props;

    return (
        <CustomStyledInput type="file" accept="csv/*" disabled={disabled} onChange={onChange}/>
    );
}

CsvUploadFile.propTypes = {onFileUpload: PropTypes.func};
CsvUploadFile.defaultProps = {};

export default CsvUploadFile;
